module.exports = __webpack_public_path__ + "7fa1e253f46936c22b4a8742fe85b1da.svg";